module.exports = __webpack_public_path__ + "static/media/stay.d0468044.png";